import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { CsgUtils } from "../CsgUtils";
import { ElementGeometry } from "./ElementGeometry";
import { RoomManager } from './../../RoomManager';
import { Util } from "../../utils/Util";
import { BoolProperty, PropertyChangedResult } from "@egr/wcf/modules/core/prop";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
export class Floor extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mPoints = new Array();
        this.mCentroid = new Vector3(0, 0, 0);
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.floorColor = "#aaaaaa";
        this.mRoomElement.Params.floorTransparent = true;
        this.mMaterial = null;
    }
    getType() {
        return ("Floor");
    }
    setMesh(pMesh) {
        //
    }
    getPoints() {
        return this.mPoints;
    }
    getPolygon(pOffset = true) {
        let tpolygonPoints = [];
        let tlinePoints = this.mPoints;
        for (let tP of tlinePoints) {
            let tnodePos = new Vector3(0, 0, 0);
            if (pOffset)
                tnodePos = this.mRoomElement.position.clone();
            let tnP = tP.add(Util.to2d(tnodePos));
            tpolygonPoints.push(Util.to3d(tnP));
        }
        return (tpolygonPoints);
    }
    correctDirection() {
        let tClockwise = Util._clockWise3(Util.to3dArray(this.mPoints));
        if (tClockwise)
            this.mPoints.reverse();
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.height = 0;
        tParams.floorOffset = 0.0;
        tParams.color = "#aaaaaa";
        return (tParams);
    }
    create2dGeometry(pParent) {
        this.calcSize();
        let tFloor = this.createFloor(pParent);
        if (tFloor != null) {
            this.mRoomElement.setMesh2d(tFloor);
        }
    }
    create3dGeometry(pParent) {
        let tFloor = this.createFloor(pParent);
        if (tFloor != null) {
            this.mRoomElement.setMesh3d(tFloor);
        }
    }
    getProperties() {
        let tProperties = new Array();
        let tYesNoChoices = new Array();
        for (let tYesNo of this.mRoomManager._YesNo)
            tYesNoChoices.push(this.mRoomManager._getYesNoPropValue(tYesNo));
        //floor visibility / transparency
        let tFloorVisibleProp = new BoolProperty(this.mRoomElement, Floor.PROP_FLOOR_TRANSPARENT, this.mRoomManager.resources.propertyTransparent);
        tFloorVisibleProp.choiceList = true;
        tFloorVisibleProp.getChoices = () => Promise.resolve(tYesNoChoices);
        tFloorVisibleProp.getValue = () => this.mRoomManager._getYesNoPropValue(this.mRoomElement.Params.floorTransparent);
        tFloorVisibleProp.setValue = (pValue) => {
            if (pValue != null) {
                let tval = BoolProperty.ConvertValueToBool(pValue);
                this.setVisibilty(tval);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tFloorVisibleProp.visible = true;
        tProperties.push(tFloorVisibleProp);
        return (tProperties);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData) {
        let tParams = pData;
        let tPoints = new Array();
        if (tParams.floorTransparent !== undefined)
            this.mRoomElement.Params.floorTransparent = tParams.floorTransparent;
        if (tParams.ElementPoints != null) {
            for (let tEP of tParams.ElementPoints) {
                let tP = new Vector2(0, 0);
                tP.x = tEP.x;
                tP.y = tEP.y;
                tPoints.push(tP);
            }
            this.setPoints(tPoints);
        }
    }
    setPoints(pPoints) {
        this.mPoints = pPoints;
        this.correctDirection();
        this.mRoomElement.Params.ElementPoints = Util.to3dArray(pPoints);
        let tarea = this.calc_area();
        this.mRoomElement.setArea(tarea);
    }
    getEOXDescription(pDocument, pParentNode) {
        let tAttribsList = new Array();
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "structure_type", value: "Floor" });
        let tRoomElementNode = Util._xmlAddChildNode(pDocument, pParentNode, "object", "", tAttribsList);
        // define category
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "category", "Other", null);
        // color
        tAttribsList = [];
        if (this.mRoomElement.color.trim() !== '') {
            let tcolor = Util.hexToRGB(this.mRoomElement.color);
            tAttribsList.push({ qualifiedName: "r", value: tcolor.r.toString() });
            tAttribsList.push({ qualifiedName: "g", value: tcolor.g.toString() });
            tAttribsList.push({ qualifiedName: "b", value: tcolor.b.toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "color", "", tAttribsList);
        }
        // position
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "x", value: this.mRoomElement.node.position.x.toString() });
        tAttribsList.push({ qualifiedName: "y", value: (this.mRoomElement.node.position.y).toString() });
        tAttribsList.push({ qualifiedName: "z", value: (-this.mRoomElement.node.position.z).toString() });
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "position", "", tAttribsList);
        // points
        for (let tP of this.mRoomElement.Params.ElementPoints) {
            tAttribsList = [];
            //let tEOXpoint = Vector3.TransformCoordinates(tP, this.mRoomElement.transform);
            let tEOXpoint = tP.clone();
            tAttribsList.push({ qualifiedName: "x", value: tEOXpoint.x.toString() });
            tAttribsList.push({ qualifiedName: "y", value: tEOXpoint.y.toString() });
            tAttribsList.push({ qualifiedName: "z", value: (-tEOXpoint.z).toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "vertex", "", tAttribsList);
        }
    }
    calcSize() {
        if (this.mPoints.length === 0)
            return;
        let tminX = this.mPoints[0].x;
        let tminY = this.mPoints[0].y;
        let tmaxX = this.mPoints[0].x;
        let tmaxY = this.mPoints[0].y;
        for (let tPoint of this.mPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.y, tminY);
            tmaxY = Math.max(tPoint.y, tmaxY);
        }
        this.mWidth = tmaxX - tminX;
        this.mDepth = tmaxY - tminY;
        this.mRoomElement.setWidth(this.mWidth, false);
        this.mRoomElement.setDepth(this.mDepth, false);
    }
    calc_area() {
        let tArea = 0;
        let tP1 = new Vector2(0, 0);
        let tP2 = new Vector2(0, 0);
        for (let i = 0, j = this.mPoints.length - 1; i < this.mPoints.length; j = i, i += 1) {
            tP1 = this.mPoints[i];
            tP2 = this.mPoints[j];
            tArea += tP1.x * tP2.y;
            tArea -= tP1.y * tP2.x;
        }
        tArea *= 0.5;
        return (Math.abs(tArea));
    }
    setVisibilty(pValue) {
        this.mRoomElement.Params.floorTransparent = pValue;
        this.mRoomElement.updateFloorReference();
        this.mRoomElement.updateGeometry_GEO();
    }
    createCSG(pParent) {
        this.correctDirection();
        let tP = this.getPolygon(false);
        let tPoints = new Array();
        for (let tPnt of tP) {
            tPoints.push(new CSG.Vector2D(tPnt.x, tPnt.z));
        }
        let tCAGshape = CAG.fromPointsNoCheck(tPoints);
        if (!tCAGshape.isSelfIntersecting()) {
            this.mRoomElement.setCAG(tCAGshape);
            let tCSG = Util.CAG2CSG(tCAGshape);
            this.mRoomElement.setCSG(tCSG);
            let tMeshes = CsgUtils.buildMeshes(tCSG, this.mScene);
            if (tMeshes == null)
                return (null);
            this.mRoomElement.setArea(tCAGshape.area());
            for (let tMesh of tMeshes) {
                // let tMat = this.mRoomManager.MatManager.getMaterial(this.mRoomElement.materialId);
                // if (tMat != null) {
                //     tMesh.material = tMat;
                // }
                tMesh.material = this.mRoomElement.localMaterial;
                if (this.mRoomElement.GroupMeshOpacity !== 1) {
                    tMesh.renderingGroupId = 1;
                }
                tMesh.visibility = this.mRoomElement.GroupMeshOpacity;
                tMesh.visibility = this.mRoomElement.Params.floorTransparent ? RoomManager.ROOM_FLOOR_OPACITY_VALUE : 1;
                tMesh.name = "shape2d_rectangle";
                tMesh.parent = pParent;
                tMesh.receiveShadows = true;
                ShadowGenerator.disableMeshShadow(tMesh);
            }
            return (tMeshes[0]);
        }
        return (null);
    }
    createFloor(pParent) {
        if (this.mPoints.length === 0)
            return (null);
        let tMesh = this.createCSG(pParent);
        return (tMesh);
    }
}
Floor.PROP_KEY_COLOR = "room:RoomElement:color";
Floor.PROP_FLOOR_TRANSPARENT = "room:RoomElement:floorTransparent";
